<ziro-select [fieldId]="'site'"></ziro-select>

@if (isValidCluster) {
  <div>
    <ziro-loading-block [hidden]="!isGettingDevicePools"></ziro-loading-block>
    @if (!isGettingDevicePools) {
      <div [attr.data-automation]="'warning-container'">
        <hr />
        @if (servicesToUpdate.length) {
          <div data-automation="change-site-service-to-update-container">
            @if (!ldapAttribute || !ldapAttribute.site) {
              <p
                [innerHTML]="'tkey;change.site.confirm_site_change.text_1' | escapeHtml"
                data-automation="change-site-service-to-update-container-text"
              ></p>
            }
            @if (ldapAttribute?.site) {
              <p
                [innerHTML]="'tkey;change.site.confirm_site_change.text_1.writeToSiteEnabled' | escapeHtml"
                data-automation="change-site-service-to-update-container-text-ldap"
              ></p>
            }
            <ul>
              @for (service of servicesToUpdate; track service) {
                <li data-automation="change-site-service-to-update">
                  <strong>
                    <i class="{{ service.icon }} me-1"></i>
                    {{ service.type | translate }}
                  </strong>
                  {{ service.name }}
                </li>
              }
            </ul>
          </div>
        }
        @if (servicesToDelete.length) {
          <div data-automation="change-site-service-to-delete-alert" class="alert alert-danger">
            <p
              data-automation="change-site-service-to-delete-alert-text-1"
              class="strong"
              [innerHTML]="'tkey;change.site.confirm_site_change.text_2' | escapeHtml"
            ></p>
            <ul>
              @for (service of servicesToDelete; track service) {
                <li data-automation="change-site-service-to-delete">
                  <strong>
                    <i class="{{ service.icon }} me-1"></i>
                    {{ service.type | translate }}
                  </strong>
                  {{ service.name }}
                </li>
              }
            </ul>
            <p
              data-automation="change-site-service-to-delete-alert-text-2"
              [innerHTML]="'tkey;change.site.confirm_site_change.text_3' | escapeHtml: { siteName: selectedSite.name }"
              class="mb-0"
            ></p>
          </div>
        }
        <div data-automation="change-site-warning-alert" class="alert alert-warning">
          <i [ngClass]="ziroIcons.WARNING_TRIANGLE + ' me-1'"></i>
          <strong>{{ 'tkey;change.site.confirm_site_change.text_4' | translate }}</strong>
        </div>
        <p data-automation="change-site-confirmation-text">
          <strong>{{ 'tkey;change.site.confirm_site_change.footer' | translate }}</strong>
        </p>
        <hr />
      </div>
    }
  </div>
}

<div class="text-end">
  @if (!isSubmitting && isFormSubmitted && validationState === ValidationState.INVALID) {
    <div data-automation="ziro-error-alert">
      <div class="alert ziro-error-alert alert-danger animate__animated animate__shakeX text-start" role="alert">
        <i [class]="ziroIcons.EXCLAMATION" class="fa-lg"></i>
        <span class="strong">
          {{ 'tkey;validators.global.required.missing.error' | translate }}
        </span>
      </div>
    </div>
  }

  <ziro-button
    [dataAutomation]="'change-site-cancel-button'"
    [buttonStyle]="buttonStyles.OUTLINE_DEFAULT"
    [label]="'tkey;dialogs.button.cancel'"
    [cssClass]="'me-1'"
    [isDisabled]="isSubmitting"
    (clicked)="onCancelClicked()"
  ></ziro-button>
  <ziro-submit-button
    [isPending]="isSubmitting"
    [dataAutomation]="'change-site-button'"
    [iconPending]="ziroIcons.SAVING"
    [buttonStyle]="buttonStyles.OUTLINE_PRIMARY"
    [label]="'tkey;change.site.change_site'"
    [formSubmitSubject]="_validateAndSubmitSource"
  ></ziro-submit-button>
</div>
